import axios from "axios";
import url from "../config/urlServiceConfig";

const objectiveAPI = {
  getAll: () => axios.get(url.objective),
  getById: (id) => axios.get(`${url.objective}/${id}`),
  create: (body) => axios.post(url.objective, body),
  update: (body) => axios.put(url.objective, body),
  delete: (id) => axios.delete(`${url.objective}/${id}`),
  getAllWithKPIs: (params) => axios.get(`${url.objective}/KPIs`, { params }),
  getObjectivesByStrategy: (params) =>
    axios.get(`${url.strategy}/ObjectivesList`, { params }),
  getObjectivesByThemes: () => axios.get(`Themes/Objectives`),
  getObjectivesByPillars: () => axios.get(`Pillars/Objectives`),
};

export default objectiveAPI;
